import React from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import UserProfile from './UserProfile'
import { MAIN_MENU } from '../../constants/ServerUrl'
import { HomeFilled, HourglassOutlined } from '@ant-design/icons'
import { FaCity, FaBook, FaWrench } from 'react-icons/fa'

const { SubMenu, ItemGroup } = Menu

const SidebarContent = () => {
  const { pathname } = useSelector(({ common }) => common)

  const selectedKey = pathname.substring(1)
  const defaultOpenKey = selectedKey.split('/')[1]

  return (
    <div className='h-full flex flex-col bg-white'>
      {/* Profile */}
      <div className='flex items-center justify-center py-5 px-4 border-b border-gray-100'>
        <UserProfile />
      </div>

      <Menu
        className='sidebar-menu flex-1 border-0 py-3 px-2'
        mode='inline'
        theme='light'
        defaultOpenKeys={[defaultOpenKey]}
        selectedKeys={[selectedKey]}
      >
        <ItemGroup key='main'>
          <Menu.Item key='home' icon={<HomeFilled className='text-lg' />}>
            <a
              onClick={() => {
                window.location.href = MAIN_MENU
              }}
            >
              Home
            </a>
          </Menu.Item>

          <Menu.Item key='dashboard' icon={<HourglassOutlined className='text-lg' />}>
            <Link to='/home'>Dashboard</Link>
          </Menu.Item>
        </ItemGroup>

        <ItemGroup
          key='recruitment'
          title={
            <span className='text-[11px] font-semibold tracking-wider text-gray-400 pl-2'>
              RECRUITMENT
            </span>
          }
        >
          <SubMenu
            key='company'
            icon={<FaCity className='text-base' />}
            title='Company'
          >
            <Menu.Item key='company/clients'>
              <Link to='/company/clients'>Clients</Link>
            </Menu.Item>
            <Menu.Item key='company/jobs'>
              <Link to='/company/jobs'>Jobs & Vacancies</Link>
            </Menu.Item>
            <Menu.Item key='company/candidates'>
              <Link to='/company/candidates'>Candidates</Link>
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key='applications'
            icon={<FaBook className='text-base' />}
            title='Applications'
          >
            <Menu.Item key='applications/registered-users'>
              <Link to='/applications/registered-users'>Registered Users</Link>
            </Menu.Item>
            <Menu.Item key='applications/application-center'>
              <Link to='/applications/application-center'>Application Center</Link>
            </Menu.Item>
            <Menu.Item key='applications/progress-timeline'>
              <Link to='/applications/progress-timeline'>Progress Timeline</Link>
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key='setup'
            icon={<FaWrench className='text-base' />}
            title='General Setup'
          >
            <Menu.Item key='setup/application-tasks'>
              <Link to='/setup/application-tasks'>Application Tasks</Link>
            </Menu.Item>
            <Menu.Item key='setup/job-descriptions'>
              <Link to='/setup/job-descriptions'>Job Descriptions</Link>
            </Menu.Item>
            <Menu.Item key='setup/job-functions'>
              <Link to='/setup/job-functions'>Job Functions</Link>
            </Menu.Item>
            <Menu.Item key='setup/job-locations'>
              <Link to='/setup/job-locations'>Job Locations</Link>
            </Menu.Item>
            <Menu.Item key='setup/company-profile'>
              <Link to='/setup/company-profile'>Company Profile</Link>
            </Menu.Item>
          </SubMenu>
        </ItemGroup>
      </Menu>

      {/* Scoped overrides — modern, minimal antd Menu styling */}
      <style>{`
        .sidebar-menu .ant-menu-item,
        .sidebar-menu .ant-menu-submenu-title {
          border-radius: 8px;
          margin: 2px 0;
          font-size: 14px;
          font-weight: 500;
          color: #4b5563;
          transition: background-color 0.15s ease, color 0.15s ease;
        }
        .sidebar-menu .ant-menu-item:hover,
        .sidebar-menu .ant-menu-submenu-title:hover {
          background-color: #f3f4f6;
          color: #111827;
        }
        .sidebar-menu .ant-menu-item-selected {
          background-color: #eef2ff !important;
          color: #4338ca !important;
          font-weight: 600;
        }
        .sidebar-menu .ant-menu-item-selected::after,
        .sidebar-menu .ant-menu-submenu-title::after {
          display: none !important;
        }
        .sidebar-menu .ant-menu-item .anticon,
        .sidebar-menu .ant-menu-submenu-title .anticon {
          margin-right: 10px;
        }
        .sidebar-menu .ant-menu-sub.ant-menu-inline {
          background: transparent;
        }
        .sidebar-menu .ant-menu-item-group-title {
          padding: 16px 12px 8px;
        }
      `}</style>
    </div>
  )
}

export default SidebarContent